import { render, staticRenderFns } from "./multiplegroup_autocomplete.vue?vue&type=template&id=6487ac3a&"
import script from "./multiplegroup_autocomplete.vue?vue&type=script&lang=js&"
export * from "./multiplegroup_autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports